"use client";
import { LandingSiteTemplateGetDataOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage, SmartLink } from "@/Components";
import { useT } from "@/Hooks";
import { useState } from "react";
// import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import SocialNetworks from "./SocialNetworks";

interface OffcanvasProps {
  data: LandingSiteTemplateGetDataOutputApiModel;
}

const Offcanvas: React.FC<OffcanvasProps> = ({ data }) => {
  const t = useT();
  const commonData = data.CommonData;
  // const images = [
  //   {
  //     src:
  //       commonData.Image?.Url ??
  //       "/Templates/Doccure/img/banner/about-img-1.jpg",
  //   },
  // ];

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openLightbox = (i: number) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <>
      {/* start offcanvas */}
      <div
        className="offcanvas offcanvas-offset offcanvas-end support_popup"
        tabIndex={-1}
        id="support_item"
      >
        <div className="offcanvas-header">
          <SmartLink href="/">
            <SmartImage
              src={commonData.Image?.Url ?? "/Templates/Doccure/img/logo.svg"}
              alt={commonData.Image?.AltText ?? commonData.Name}
              className="img-fluid logo"
            />
          </SmartLink>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="isax isax-close-circle" />
          </button>
        </div>

        <div className="offcanvas-body">
          {/* Item 1 */}
          <div className="about-popup-item">
            <h3 className="title">
              {t("landing.footer.aboutCenter", { name: commonData.Name })}
            </h3>
            {commonData.BriefDescription && (
              <p>{commonData.BriefDescription}</p>
            )}

            {/* <div className="about-img d-flex align-items-center gap-2 justify-content-between">
              {images.map((img, i) => (
                <button
                  key={i}
                  onClick={() => openLightbox(i)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                >
                  <SmartImage
                    src={img.src}
                    alt={`about-${i}`}
                    className="img-fluid"
                  />
                </button>
              ))}
            </div> */}
          </div>

          {/* Item 2 */}
          <div className="about-popup-item">
            <h3 className="title">
              {t("landing.footer.address")}
            </h3>
            {(commonData.Address || commonData.Location) && (
              <div className="loction-item">
                <h4 className="title">{commonData.Name}</h4>
                <p className="location">
                  {commonData.Address ?? commonData.Location}
                </p>
              </div>
            )}
          </div>

          {/* Item 3 */}
          <div className="about-popup-item">
            <h3 className="title">
              {t(
                "landing.header.contactInformation",
                undefined,
                "Contact Information",
              )}
            </h3>

            {commonData.Email && (
              <div className="support-item mb-3">
                <div className="avatar avatar-lg bg-primary rounded-circle">
                  <i className="isax isax-messages-3" />
                </div>
                <div>
                  <p className="title">
                    {t(
                      "landing.footer.generalInquiries",
                      undefined,
                      "General Inquiries",
                    )}
                  </p>
                  <h5 className="link">
                    <SmartLink href={`mailto:${commonData.Email}`}>
                      {commonData.Email}
                    </SmartLink>
                  </h5>
                </div>
              </div>
            )}

            {commonData.Tels.map((tel) => (
              <div className="support-item mb-3" key={tel}>
                <div className="avatar avatar-lg bg-primary rounded-circle">
                  <i className="isax isax-call-calling" />
                </div>
                <div>
                  <p className="title">
                    {t("landing.footer.phone", undefined, "Phone")}
                  </p>
                  <h5 className="link">
                    <SmartLink href={`tel:${tel}`}>{tel}</SmartLink>
                  </h5>
                </div>
              </div>
            ))}
          </div>

          {/* Social */}
          {commonData.SocialNetworks.length > 0 && (
            <div className="about-popup-item border-0">
              <h3 className="title">
                {t("landing.header.followUs", undefined, "Follow Us")}
              </h3>
              <ul className="d-flex align-items-center gap-2 social-iyem">
                <SocialNetworks
                  socialNetworks={commonData.SocialNetworks}
                  wrapWithLi
                  linkClassName="social-icon"
                />
              </ul>
            </div>
          )}
        </div>

        <SmartImage
          src="/Templates/Doccure/img/bg/offcanvas-bg.png"
          alt="element"
          className="element-01"
        />
      </div>
      {/* end offcanvas */}

      {/* Lightbox */}
      {/* <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={images}
        index={index}
        on={{ view: ({ index }) => setIndex(index) }}
      /> */}
    </>
  );
};

export default Offcanvas;
